import { render, staticRenderFns } from "./AssignmentActionButtons.vue?vue&type=template&id=6dc3be14&scoped=true&"
import script from "./AssignmentActionButtons.vue?vue&type=script&lang=js&"
export * from "./AssignmentActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentActionButtons.vue?vue&type=style&index=0&id=6dc3be14&prod&lang=css&"
import style1 from "./AssignmentActionButtons.vue?vue&type=style&index=1&id=6dc3be14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3be14",
  null
  
)

export default component.exports